import type { AnalyticsConfig } from './types';

/**
 * B2B internal tool — analytics consent is implicit for authenticated employees.
 * TODO: Revisit if app becomes public-facing or subject to ePrivacy requirements.
 */
export function hasAnalyticsConsent(): boolean {
  return true;
}

function getEnvVar(key: string): string | undefined {
  return import.meta.env[key] as string | undefined;
}

export function getAnalyticsConfig(): AnalyticsConfig {
  const envStr = getEnvVar('VITE_ANALYTICS_ENV') || (import.meta.env.DEV ? 'local' : 'production');
  const environment = envStr as AnalyticsConfig['environment'];

  const sampleRateStr = getEnvVar('VITE_AMPLITUDE_SESSION_REPLAY_SAMPLE_RATE');
  const sampleRate = sampleRateStr
    ? Number.parseFloat(sampleRateStr)
    : environment === 'production'
      ? 0.1
      : 1;

  return {
    environment,
    amplitudeApiKey: getEnvVar('VITE_AMPLITUDE_API_KEY') || '',
    amplitudeSessionReplaySampleRate: sampleRate,
  };
}
